// ------------------------------------
// Constants
// ------------------------------------

/* Realiza petición de productos, boleto y metricas */
export const FETCH_COMPUTED_PRODUCTS_TICKET_METRICS = 'FETCH_COMPUTED_PRODUCTS_TICKET_METRICS';
/* Realiza petición de productos y metricas */
export const FETCH_COMPUTED_PRODUCTS_METRICS = 'FETCH_COMPUTED_PRODUCTS_METRICS'
/* Finalizar sesion y ticket */
export const FINISH_COMPUTED_SESSION_TICKET = 'FINISH_COMPUTED_SESSION_TICKET'
/* Obtener cuestionarios y productos */
export const FETCH_COMPUTED_QUESTIONS_PRODUCTS = 'FETCH_COMPUTED_QUESTIONS_PRODUCTS'

// ------------------------------------
// Actions
// ------------------------------------

export function fetchComputedProductsTicketMetrics (token, idSession, idMarket, idPais, combinacion, callback = null) {
  return {
    type: FETCH_COMPUTED_PRODUCTS_TICKET_METRICS,
    token,
    idSession,
    idMarket,
      idPais,
    combinacion,
    callback
  }
}

export function fetchComputedProductsMetrics (token, idMarket, idPais, callback) {
  return {
    type: FETCH_COMPUTED_PRODUCTS_METRICS,
    token,
    idMarket,
      idPais,
    callback
  }
}

export function finishComputedSessionTicket (token, ticket, callback = null) {
  return {
    type: FINISH_COMPUTED_SESSION_TICKET,
    token,
    ticket,
    callback
  }
}

export function fetchComputedQuestionsProducts (token, idMarket, idPais, callback = null) {
  return {
    type: FETCH_COMPUTED_QUESTIONS_PRODUCTS,
    token,
    idMarket,
    idPais,
    callback
  }
}


export const actions = {
  fetchComputedProductsTicketMetrics,
  fetchComputedProductsMetrics
};



// WEBPACK FOOTER //
// ./src/store/modules/module_computed_products.js